import { render, staticRenderFns } from "./Gpt.vue?vue&type=template&id=0500f968&scoped=true&"
import script from "./Gpt.vue?vue&type=script&lang=js&"
export * from "./Gpt.vue?vue&type=script&lang=js&"
import style0 from "./Gpt.vue?vue&type=style&index=0&id=0500f968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500f968",
  null
  
)

export default component.exports